import React from "react";

import { withStyles } from "@material-ui/styles";
import authStore from "../../authStore";
import { observer } from "mobx-react";
import { locations, reports, users } from "../../firestorter";
import { Redirect } from "react-router-dom";
import UsersTable from "../UsersTable";
import LocationsTable from "../LocationsTable";

const classes = {
  panel: {
    backgroundColor: "#b14d9b",
    color: "white",
    textAlign: "center",
    padding: "1rem",
  },
};

const Manage = observer(
  class Manage extends React.Component {
    constructor() {
      super();
      this.state = {
        searchTerm: "",
        user: authStore.user.get(),
        context: "users",
      };
    }

    componentDidMount() {
      const headerElem = document.getElementById("header");
      if (headerElem) {
        this.setState({ height: window.innerHeight - headerElem.offsetHeight });
      }
      locations.query = locations.ref.orderBy("name", "asc");
    }

    orderLocationsBy(prop) {
      locations.query = locations.ref.orderBy(prop, "asc");
    }

    onSearchTermChanged(event) {
      const updateParams = { searchTerm: event.target.value };

      this.setState(updateParams);
    }

    componentWillUnmount() {
      locations.query = null;
    }

    setContext(context) {
      this.setState({ context });
    }

    render() {
      const { classes } = this.props;

      const collectionDocs =
        this.state.context == "location" ? locations.docs : users.docs;

      const _items =
        collectionDocs.length && this.state.context == "location" ? (
          <LocationsTable locations={collectionDocs} />
        ) : (
          <UsersTable users={collectionDocs} />
        );

      return (
        <div
          className={classes.panel}
          style={{
            height: `${this.state.height}px`,
            flex: 1,
            overflow: "auto",
          }}
        >
          {this.state.user ? (
            <div>
              <div style={{ marginTop: "1rem" }}>
                <div>
                  <a
                    href="javascript:;"
                    onClick={function () {
                      this.setContext("location");
                    }.bind(this)}
                  >
                    מיקומים
                  </a>{" "}
                  |
                  <a
                    href="javascript:;"
                    onClick={function () {
                      this.setContext("users");
                    }.bind(this)}
                  >
                    משתמשים
                  </a>
                </div>

                <div>סה"כ: {collectionDocs.length}</div>
                
              </div>
              <div style={{ backgroundColor: "white" }}>{_items}</div>
            </div>
          ) : (
            <Redirect to="/" />
          )}
        </div>
      );
    }
  }
);

export default withStyles(classes)(Manage);
